"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hidePreWarnPopup = undefined;

var _getSimilarTy = require("./getSimilarTy");

var _tips = require("./util/tips");

var _alarmArea = require("./business/alarmArea");

var _area = _interopRequireWildcard(_alarmArea);

var _judgeArea = require("./business/judgeArea");

var _wind = require("./util/wind");

var _viewer = require("./business/viewer");

var _overlay = require("./util/overlay");

var overlay = _interopRequireWildcard(_overlay);

var _boundary2 = require("./boundary");

var _boundary3 = _interopRequireDefault(_boundary2);

var _newsTip = require("./util/newsTip");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var tyInterval = setInterval(function () {
  var fstAreas = window.fstAreas;
  if (window.locationInfo && (fstAreas === false || Array.isArray(fstAreas) && fstAreas.length === currentTyNum)) {
    $(".decisionArea").click();
    clearInterval(tyInterval);
  }
}, 500);
var spots_global = {};

var hasLoadSpot = true;
var initTySpot = function initTySpot() {
  hasLoadSpot = false;
  _area.getTyphoonspot().then(function (res) {
    console.log(res);
    if (res.result !== "S_OK") {
      hasLoadSpot = true;
      return;
    }
    var spots = res.tagObject.spots;

    var hasSZPoint = false;var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = spots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _spot = _step.value;

        if (_spot.lon === 113.92 && _spot.lat === 22.48) {
          hasSZPoint = true;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (!hasSZPoint) {
      _area.addTyphoonspot("22.48", "113.92", [200, 400, 600, 800]).then(function (res) {
        initTySpot();
      });
    } else {
      var promiseList = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = spots[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var spot = _step2.value;

          spots_global[spot.typhoonspotid] = spot;
          var lat = spot.lat,
              lon = spot.lon,
              radius = spot.radius,
              typhoonspotid = spot.typhoonspotid;
          if (!Array.isArray(radius)) continue;
          var radiusArr = radius.sort(function (a, b) {
            return a < b;
          });
          var maxRadiu = radiusArr[0];
          var bool = (0, _judgeArea.judge)(lat, lon, maxRadiu);
          promiseList.push(getInterpPoints(lon, lat, radius, typhoonspotid, bool));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      Promise.all(promiseList).then(function () {
        hasLoadSpot = true;
      });
    }
  });
};
$(".decisionArea").click(function (e) {
  e.stopPropagation();
  if (!hasLoadSpot) return;
  var el = $(".cloudMap li.tyListUl_com").eq(0);
  if ($(this).hasClass("on")) {
    el.hide();
    _area.clearAllInfo();
  } else {
    el.show();
    initTySpot();
  }
  $(this).toggleClass("on");
});

var getInterpPoints = function getInterpPoints(lon, lat, radius, typhoonspotid, bool) {
  var date = new Date().Format("yyyy/MM/dd 20:00:00");
  date = new Date(date).getTime();
  var nowTime = Date.now();
  if (date < nowTime) {
    date = new Date().Format("yyyy/MM/dd 08:00:00");
  } else {
    date = date - 24 * 60 * 60 * 1000;
    date = new Date(date).Format("yyyy/MM/dd 08:00:00");
  }

  var url = window.PAGE_CONFIG.BASE_URL + "/Alarm/getInterpPoints?datetime=" + date + "&leadtime=0&points[0][]=" + lon + "&points[0][]=" + lat + "&cacheCtrl=" + Date.now();
  var stormUrl = window.PAGE_CONFIG.BASE_URL + "/Alarm/getTideInterpPoints?datetime=" + date + "&leadtime=0&points[0][]=" + lon + "&points[0][]=" + lat + "&cacheCtrl=" + Date.now();
  var data = void 0;
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: url,
      timeout: 2000,
      success: function success(res) {
        if (/DB_ERROR/.test(res) || /null/.test(res) || !res.length) {
          _area.addArea(lat, lon, radius, typhoonspotid, bool, {});
          resolve();
          return;
        }
        data = res[0];
        for (var i in data) {
          if (/null/.test(data[i]) || data[i] === -999.9) data[i] = "";
        }
        if (data.windPower) data.windPower = (0, _wind.getVelLevel)(data.windPower);
        if (data.windDirection) data.windDirection = (0, _wind.getDirLevel)(data.windDirection);
        if (data.waveHeight) data.waveHeight = data.waveHeight.toFixed(2);
        if (data.waveProid) data.waveProid = data.waveProid.toFixed(2);
        if (data.waveDir) data.waveDir = (0, _wind.getDirLevel)(data.waveDir).replace("风", "");
        $.ajax({
          url: stormUrl,
          timeout: 5000
        }).then(function (msg) {
          if (!msg || /DB_ERROR/.test(msg) || /null/.test(msg) || !msg.length) data.windWater = 0;
          data.windWater = msg[0];
          if (data.windWater) data.windWater = data.windWater.toFixed(2);else data.windWater = 0;
          if (data.windPower >= 7) bool = true;
          _area.addArea(lat, lon, radius, typhoonspotid, bool, data);
          resolve();
        });
      },
      error: function error(err) {
        _area.addArea(lat, lon, radius, typhoonspotid, bool, {});
        resolve();
      }
    });
  });
};

var simObj = {
  similar: ".typhoon_cusWin"
};
var susNavObj = {
  typhoon: "#tyChangeWraper",
  seaWave: ".tycontener_bottSeawave",

  thunder: ".rainstormImg",
  actual: ".actualImg"
};
var windRequest = null;
var realWindLayer = null;
var windTimeStamp = null;
$("#tyswNav>ul>li").on("click", function () {
  hidePreWarnPopup();
  if (val !== "typhoon" && $(".simiMatch").hasClass("on")) $(".closeSimi").click();
  if ($(".cloudMap ul li img.on").length) $(".cloudMap ul li img.on").click();
  if ($(".cloudMap ul li:nth-child(1).on").length) $("#makePolicy").click();
  if ($(".imgEx").hasClass("on")) $(".imgEx").click();

  var $dom = $(this);
  var val = $(this).attr("name");
  var url = void 0;
  if ($(this).hasClass("a")) {
    if (val === "typhoon" && !$("#tyChangeWraper li.layer-selected, .defenceArea.on, .decisionArea.on").length || val === "cloud" && !$(".rdList .on").length || val === "thunder" && !$(".rainstormImg li.on").length || val === "actual" && !$(".actualImg li.on").length) {
      $(this).removeClass("on");
    }
    $(susNavObj[val]).hide();
  } else {
    if (val === "seawave" || val === "cloud") {
      if (windRequest) {
        windRequest.abort();
        windRequest = null;
      }
      $(this).toggleClass("on");

      if ($(".swList").hasClass("on")) {
        $(".cloudPopup,.windetime").css("display", "block");

        if (!windTimeStamp) windTimeStamp = new Date().getTime();else {
          var timeDiff = new Date().getTime() - windTimeStamp;

          if (timeDiff < 900000 && realWindLayer) {
            $(this).hasClass("on") && realWindLayer.addTo(map);
            return;
          }
          windTimeStamp = new Date().getTime();
        }

        windRequest = $.ajax({
          type: "POST",

          url: window.PAGE_CONFIG.BASE_URL + "/gzh/data/model/uv/find?timeStamp=" + new Date().getTime(),
          success: function success(res) {
            var newTime = res.data.time;
            var windetimehtml = "";
            var time = new Date(newTime).Format("yyyy年MM月dd日 HH:00");
            windetimehtml = time + "  \u98CE\u573A";
            $(".windetime").html(windetimehtml);
            console.log();
            windRequest = null;
            if (!$dom.hasClass("on")) return;
            if (!res || res.result !== "S_OK") {
              (0, _newsTip.showTipInfo)("无风场数据");
              return;
            }
            var tempData = res.data;
            var us = tempData.us,
                vs = tempData.vs,
                windInfo = tempData.modelinfo;
            var infos = {
              left: windInfo.left,
              right: windInfo.right,
              top: windInfo.top,
              bottom: windInfo.bottom,
              xgap: windInfo.colDelta,
              ygap: windInfo.rowDelta,
              xdim: windInfo.cols,
              ydim: windInfo.rows
            };
            try {
              realWindLayer = L.beautyWindLayer(us, vs, infos, "line");

              if ($dom.hasClass("on")) {
                realWindLayer.addTo(map);
              }
            } catch (err) {
              realWindLayer = null;
              (0, _newsTip.showTipInfo)("无风场数据");
            }
          },
          error: function error() {
            windRequest = null;
            realWindLayer = null;
            (0, _newsTip.showTipInfo)("无风场数据");
          }
        });
      } else {
        if (realWindLayer) {
          map.removeLayer(realWindLayer);
        }
        $(".windetime").css("display", "none");
      }
    } else if (val === "thunder") {
      if ($(".rainForecast").hasClass("on") || $(".tgReflex").hasClass("on")) {
        $(".rainProgressbar").stop().animate({
          top: "0rem"
        }).addClass("on");
      } else if ($(".rainFallChart").hasClass("on")) {
        $(".rainFallTimeSelector").stop().animate({
          top: "0rem"
        }).addClass("on");
        $(".tyCl_list").stop().animate({
          top: "1rem"
        });
      } else {
        $(".tyCl_list").stop().animate({
          top: "0rem"
        });
      }
      $(this).addClass("on");
    } else if (val === "warning") {
      $(this).toggleClass("on");
      if ($(this).hasClass("on")) {
        getTyphoonReport();
      }
    } else {
      $(this).addClass("on");
    }

    if (val !== "thunder") {
      if ($(".rainForecast").hasClass("on") || $(".tgReflex").hasClass("on")) {
        $(".tyCl_list").stop().animate({
          top: "0rem"
        });
      }
    }

    if (val !== "typhoon") toggleNavSel("#tyChangeWraper", ".layer-selected", ".tyList");
    if (val !== "cloud") toggleNavSel("#cloudOverlay", ".on", ".rdList");
    if (val !== "thunder") toggleNavSel(".rainstormImg", ".on", ".tsList");
    if (val !== "actual") toggleNavSel(".actualImg", ".on", ".buoyList");
    for (var i in susNavObj) {
      if (i === "typhoon" || i === "cloud" || i === "thunder" || i === "actual") $(susNavObj[i]).hide();
    }

    if (val !== "seawave" && val !== "buoy") $(susNavObj[val]).show();
  }
  $(this).siblings().removeClass("a");
  if (val !== "seawave" && val !== "buoy" && val !== "warning" && val != "cloud") $(this).toggleClass("a");
});

$(".buoyStation").click(function (e) {
  e.stopPropagation();
  if ($(this).hasClass("on")) deleBuoyData();else {
    getBuoyData();
  }
  $(this).toggleClass("on");
});

var toggleNavSel = function toggleNavSel(child, classN, parent) {
  if (!$(child + " li" + classN).length) {
    $(child).parents(parent).removeClass("on");
  }
};
var deleteOcean = function deleteOcean() {
  if ($(".tycontener_bottSeawave").hasClass("on")) {
    $(".tycontener_bottSeawave").removeClass("on").stop().animate({
      bottom: "-6rem"
    });
  }
};

$(".tySimilar>ul>li").on("click", function () {
  if ($(".simiMatch").hasClass("on")) $(".closeSimi").click();
  $(".rainProgressbar").stop().animate({
    top: "-2.67rem"
  }).removeClass("on");
  $(".tyCl_list").stop().animate({
    top: "0rem"
  });
  hidePreWarnPopup();
  $(".imgEx.on").click();
  $(".cloudMap ul li img.on").click();
  var val = $(this).attr("name"),
      $img = $(this).children("img"),
      imgUrl = $img.data("url");
  $img.attr("src", imgUrl);

  $("#tyswNav>ul>li.a").click();

  if ($(".cloudMap ul li:nth-child(1).on").length) $("#makePolicy").click();

  if (val === "similar") {
    $(this).addClass("on");
    if (!$(".drawer").hasClass("a")) {
      $(simObj[val]).show();
    }

    var tsObj = {};
    $("#tyChange .layer-selected").map(function () {
      var $child = $(this).find("a"),
          tsid = $child.attr("tsid"),
          name = $child.text();
      console.log("layer-selected", tsid, name);
      tsObj[tsid] = name;
    });
    $(".chose_cusDetales_centerTy select option").remove();
    var html = "";
    for (var i in tsObj) {
      html = "<option value=\"" + i + "\">" + tsObj[i] + "</option>" + html;
    }
    $(".chose_cusDetales_centerTy select").html(html);

    $(".cusDetales_centerTy .cusDetales_list div p").remove();
    var html1 = "";
    for (var _i in tsObj) {
      html1 = "<p value=\"" + _i + "\">" + tsObj[_i] + "</p>" + html1;
    }
    $(".cusDetales_centerTy .cusDetales_list").html(html1);
    $(".chose_typhoon_cusDetales").css("display", "block");
    $(".cusDetales_centerTy .cusDetales_list p").on("click", function (e) {

      $(this).toggleClass("cusDetales_list_show");
      $(".simiMatchCon").toggleClass("ele_hide");
      var tsid = $(".chose_cusDetales_centerTy select").val(),
          radius = $('input[name="radius"]').val();
      console.log("cusDetales_list p", tsid);
      (0, _getSimilarTy.getSimilarTyphoons)(tsid, radius);
    });
  }
});

function hideSim(popup, num) {
  $(popup).hide();
  var $target = $(".tySimilar ul li").eq(num);
  $target.removeClass("on");
  var url = $target.find("img").data("url").replace("_pre", "");
  $target.find("img").attr("src", url);
}


$(".typhoon_close,.cusDetales_cancleTy").on("click", function () {
  hideSim(".typhoon_cusWin", 0);
  $(".typhoon_cusDetales").css("display", "none");
  $(".chose_typhoon_cusDetales").css("display", "block");

  $("#simTyphoon").addClass("ele_hide");

  $("#simTyphoon ul li.simSelected").map(function () {
    $(this).click();
  });
  $(".drawer img").css("bottom", "2rem");
});

$(".cusDetales_confirmTy").on("click", function () {
  hideSim(".chose_typhoon_cusDetales", 0);
  var tsid = $(".cusDetales_centerTy select").val(),
      radius = $('input[name="radius"]').val();
  $(".typhoon_cusDetales").css("display", "none");

  $(".cusDetales_centerTy .cusDetales_list p")[0].click();

  (0, _getSimilarTy.getSimilarTyphoons)(tsid, radius);
});

$(".closeSimi").on("click", function () {
  if ($(".simiTyHide").hasClass("on")) $(".simiTyHide").removeClass("on");
  $(".simiMatch").css({
    transform: "translateY(-100%)",
    top: 0
  }).removeClass("on");

  $("#simTyphoon ul li.simSelected").map(function () {
    $(this).click();
  });
});

function togglePop($this, $pop) {
  var url = $this.data("url");
  if ($this.hasClass("on")) url = url.replace("_pre", "");
  $this.attr("src", url).toggleClass("on");
  $pop.toggle();
}
$(".cloudMap ul li img").on("click", function () {
  $(".imgEx.on").click();
  console.log("aaa");
  var className = $(this).data("class"),
      $pop = $("." + className);
  togglePop($(this), $pop);

  var $bro = $(this).parent("li").siblings(".tyListUl_com").find("img");
  if ($bro.hasClass("on")) {
    var broUrl = $bro.data("url").replace("_pre", "");
    $bro.attr("src", broUrl).removeClass("on");
    $("." + $bro.data("class")).hide();
  }

  if ($(".cloudMap ul li img.on").length) $("#tyswNav>ul>li.a").click();
});
$(".typhoonList,.cloudMap ul li:nth-child(2)").on("click", function () {
  if ($(".cloudMap ul li:nth-child(1).on").length) $("#makePolicy").click();
});

$("#makePolicy").on("click", function () {
  $(".early_warn").removeClass("on").show().stop().animate({
    bottom: "-4.8rem"
  });
  $(".rainProgressbar").stop().animate({
    top: "-2.67rem"
  }).removeClass("on");
  $(".tyCl_list").stop().animate({
    top: "0rem"
  });
  if ($(".simiMatch").hasClass("on")) $(".closeSimi").click();
  if ($(this).hasClass("on")) {
    if (map.hasEventListeners("click", getLatLngEvent)) {
      map.removeEventListener("click", getLatLngEvent);
      $(".getLonLat").hide();
    }
    var url = $(this).find("img").data("url").replace("_pre", "");
    $(this).find("img").attr("src", url);
  } else {
    var dataUrl = $("#makePolicy").find("img").data("url");
    $(this).find("img").attr("src", dataUrl);
    $(".cusLonLat_cusWin").show();
  }
  $("input[name='longitude'],input[name='latitude'],input[name='radius']").val("");
  $(this).toggleClass("on");
});

var closeAreaPopup = function closeAreaPopup() {
  $(".cusLonLat_cusWin").hide();
  var $target = $("#makePolicy");
  $target.removeClass("on");
  $target.find("img").removeClass("on");

  var urlValue = $target.find("img").data("url") || '';
  var url = urlValue.replace("_pre", "");
  $target.find("img").attr("src", url);
};

$(".cusLonLat_close").on("click", function () {
  closeAreaPopup();
});

$("#customGet").on("click", function () {
  $(".cusLonLat_cusWin").hide();
  var tooltip = "<div class='getLonLat'>\u70B9\u51FB\u5730\u56FE\u83B7\u53D6\u7ECF\u7EAC\u5EA6 </div>";
  $("body").append(tooltip);
  $(".getLonLat").show();

  map.on("click", getLatLngEvent);
  var lonData = $("input[name='longitude']").val(),
      latData = $("input[name='latitude']").val(),
      radiusData = $("input[name='radius']").val();
});

$("#customConfirm").on("click", function () {
  var lonData = $("input[name='longitude']").val(),
      latData = $("input[name='latitude']").val();
  var rArr = [];
  $("input[name='radius']").map(function () {
    var val = Number($(this).val());

    if (val) rArr.push(val);
  });
  rArr.sort(function (a, b) {
    return a > b;
  });
  if (!lonData || !latData || !rArr.length) (0, _tips.getNoDataTips)(".hint_noNull");else addTyphoonspot(latData, lonData, rArr);
});

var getLatLngEvent = function getLatLngEvent(pos) {
  $(".getLonLat").remove();
  $(".cusLonLat_cusWin").fadeIn(function () {
    var latlng = pos.latlng;
    var longitude = latlng.lng.toFixed(5),
        latitude = latlng.lat.toFixed(5);
    $('input[name="longitude"]').val(longitude);
    $('input[name="latitude"]').val(latitude);
  });
  map.off("click", getLatLngEvent);
};

var addTyphoonspot = function addTyphoonspot(lat, lon, radius) {
  _area.addTyphoonspot(lat, lon, radius).then(function (res) {
    if (res.result !== "S_OK") return;
    var pointId = res.tagObject.typhoonspotid;
    var radiusArr = radius.sort(function (a, b) {
      return a < b;
    });
    var maxRadiu = radiusArr[0];
    var bool = (0, _judgeArea.judge)(lat, lon, maxRadiu);
    getInterpPoints(lon, lat, radiusArr, pointId, bool);
    spots_global[pointId] = res.tagObject;
  });
  closeAreaPopup();
};

$(".imgEx").on("click", function () {

  $(".imgEx_details").toggleClass("show");

  $(this).toggleClass("on");
  $(".cloudMap ul li:nth-child(2) img").removeClass("on");

  $(".mapImg").hide();

  if ($(".cloudMap ul li:nth-child(1).on").length) $(".cloudMap ul li.on").eq(0).click();
  closeAreaPopup();
});

var mapEvent = function mapEvent() {
  $(".buoy_bott").removeClass("on").stop().animate({
    bottom: "-5.8rem"
  });
  if ($("#tyswNav>ul>li").eq(1).hasClass("on")) return;
  if ($(".early_warn").hasClass("on")) return;
  if ($(".simiMatch").hasClass("on")) return;
  if ($(".rainProgressbar").hasClass("on")) return;
};
var contEvent = function contEvent(e) {
  if ($(e.target).attr("src") == "assets/typhoon_forecast@3x.png") return;
  if ($(e.target).is(".imgEx") || $(e.target).is(".imgEx *")) return;
  if ($(e.target).is(".cloudMap .tyListUl_com:nth-child(2)") || $(e.target).is(".cloudMap .tyListUl_com:nth-child(2) *")) return;
  if ($(e.target).is(".buoy_bott") || $(e.target).is(".buoy_bott *")) return;
  mapEvent();
};

var getBuoyData = function getBuoyData() {
  var nowTime = new Date().Format("yyyy/MM/dd HH:mm");
  $(".now_time").text(nowTime);
  var time = new Date().Format("yyyy/MM/dd HH:mm:00");
  time = new Date(time).getTime();
  time = time - time % (10 * 60 * 1000) - 10 * 60 * 1000;
  time = new Date(time).Format("yyyy/MM/dd HH:mm:00");

  var buoyUrl = window.PAGE_CONFIG.BASE_URL + "/roa1080/discrete/buoy/d3/V22041%3bV22042%3bV22043%3bV22044%3bV22062%3bV22062_001%3bV23001%3bV23001_001%3bV23002%3bV23002_001%3bV23003%3bV23003_001%3bV23004%3bV23004_001%3bV23005%3bV23006%3bV23007%3bV23007_001," + time + "/JSON?cacheCtrl=" + Date.now();

  $.ajax({
    url: buoyUrl
  }).then(function (data) {
    if (/DB_ERROR/.test(data)) {
      (0, _tips.getNoDataTips)(".buoy_noData");
      return;
    }
    data = JSON.parse(data);

    $(".conteners").click(contEvent);
    map.addEventListener("movestart", mapEvent);

    var buoyIcon = L.icon({
      iconUrl: "assets/typhoon_forecast@3x.png",
      iconSize: [25, 25],
      iconAnchor: [0, 0]
    });
    var buoyLabel = L.divIcon({
      className: "ty-name-label",
      html: "<span class=\"buoyLabel\">\u6D6E\u6807\u7AD9</span>"
    });

    data.map(function (info) {
      var center = [info.lat, info.lon];
      var events = {
        click: function click(e) {
          $(".rainProgressbar").stop().animate({
            top: "-2.67rem"
          }).removeClass("on");
          if ($(".tycontener_bottSeawave").hasClass("on")) {
            $(".tycontener_bottSeawave").removeClass("on").stop().animate({
              bottom: "-6rem"
            });
            if ($(".buoy_bott").hasClass("on")) $(".tyCl_list,.imgEx,.getLonLat,.cloudPopup").stop().animate({
              bottom: "6.466667rem"
            });else $(".tyCl_list").stop().animate({
              top: "2rem"
            });
          }
          if ($(".early_warn").hasClass("on")) $(".early_warn").removeClass("on").stop().animate({
              bottom: "-4.8rem"
            });
          if ($(".simiMatch.on").length) $(".closeSimi").click();
          $("#buoyPos").text(Math.round(Number(info.V22041) * 100) / 100 === 9999 ? "--" : (0, _wind.getDirLevel)(Math.round(Number(info.V22041) * 100) / 100).replace("风", ""));
          $("#aboveTem").text(Math.round(Number(info.V22042) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V22042) * 100) / 100 + "℃");
          $("#highTem").text(Math.round(Number(info.V22043) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V22043) * 100) / 100 + "℃");
          $("#lowTem").text(Math.round(Number(info.V22044) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V22044) * 100) / 100 + "℃");
          $("#effWaveHigh").text(Math.round(Number(info.V23002) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V23002) * 100) / 100 + "m");
          $("#effWaveHighPriod").text(Math.round(Number(info.V23002_001) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V23002_001) * 100) / 100 + "m/s");
          $("#aveWaveHigh").text(Math.round(Number(info.V23003) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V23003) * 100) / 100 + "m");
          $("#aveWaveHighPriod").text(Math.round(Number(info.V23003_001) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V23003_001) * 100) / 100 + "m/s");
          $("#bigestWaveHigh").text(Math.round(Number(info.V23004) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V23004) * 100) / 100 + "m");
          $("#bigestWaveHighPriod").text(Math.round(Number(info.V23004_001) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V23004_001) * 100) / 100 + "m/s");
          $("#oceanFlowSpeed").text(Math.round(Number(info.V23005) * 100) / 100 === 9999 ? "--" : Math.round(Number(info.V23005) * 100) / 100 + "m/s");
          $("#oceanWaveDir").text(Math.round(Number(info.V23006) * 100) / 100 === 9999 ? "--" : (0, _wind.getDirLevel)(Math.round(Number(info.V23006) * 100) / 100).replace("风", ""));
          $(".buoy_bott").addClass("on").show().stop().animate({
            bottom: 0
          });
          $(".tyCl_list,.imgEx,.getLonLat,.cloudPopup").stop().animate({
            bottom: "6.466667rem"
          });
          $(".buoy_bott").click(function (e) {
            e.stopPropagation();
          });
        }
      };
      var options = {
        icon: buoyIcon,
        zIndexOffset: 1000
      };
      overlay.addMarker("buoyPoint", center, options, events);
      overlay.addMarker("buoyPoint", center, {
        icon: buoyLabel
      }, events);
    });
  });
};

var deleBuoyData = function deleBuoyData() {
  overlay.removeOverlay("buoyPoint");
  $(".conteners").unbind("click", contEvent);
  map.removeEventListener("movestart", mapEvent);
  if ($(".buoy_bott").hasClass("on")) {
    $(".buoy_bott").removeClass("on").stop().animate({
      bottom: "-5.8rem"
    });
  }
};

$(".warnModify").on("click", function () {
  hidePreWarnPopup();
  var pointId = $(".early_head").attr("pointid");
  $("#modifyPointLon").val(spots_global[pointId].lon);
  $("#modifyPointLat").val(spots_global[pointId].lat);
  var html = "";
  spots_global[pointId].radius.map(function (r) {
    html = "<div class=\"wrapperMod clearfix\"><dt>\u534A\u5F84</dt><dd class=\"radiusIn\"><input type=\"number\" name=\"modifyRadius\" value=\"" + r + "\">\u516C\u91CC<span class=\"modifyDel\"></span></dd></div>" + html;
  });
  $(".preWarnDetales_center .wrapper").html(html);
  $(".preWarnDetales_center .wrapper .radiusIn").eq(-1).find("span").removeClass("modifyDel").addClass("modifyAdd");
  $(".preWarn_cusWin").show();
});

$(".preWarnDetales_center").on("click", ".modifyDel", function () {
  var $parent = $(this).parents(".wrapperMod");
  $parent.remove();
});

$(".preWarnDetales_center").on("click", ".modifyAdd", function () {
  $(this).removeClass("modifyAdd").addClass("modifyDel");
  $(".preWarnDetales_center .wrapper").append("<dt>\u534A\u5F84</dt><dd class=\"radiusIn\"><input type=\"number\" name=\"modifyRadius\">\u516C\u91CC<span class=\"modifyAdd\"></span></dd>");
  var height = $(".preWarnDetales_center .wrapper dt").size() * 1.25 * 75;
  $(".preWarnDetales_center .wrapper").scrollTop(height);
});

$("#preWarnConfirm").on("click", function () {
  var radius = [];
  $('input[name="modifyRadius"]').each(function () {
    if ($(this).val()) radius.push(Number($(this).val()));
  });
  radius.sort(function (a, b) {
    return a < b;
  });
  if (!$("#modifyPointLon").val() || !$("#modifyPointLat").val() || !radius.length) {
    (0, _tips.getNoDataTips)(".hint_noNull");
    return;
  }
  var lat = $("#modifyPointLat").val(),
      lon = $("#modifyPointLon").val(),
      pointId = $(".early_head").attr("pointid");
  _area.modifyTyphoonspot(lat, lon, radius, pointId).then(function (data) {
    if (data.result === "S_OK") {
      var radiusArr = radius.sort(function (a, b) {
        return a < b;
      });
      var radiusArrLen = radiusArr.length - 1;
      var maxRadiu = radiusArr[0];
      var bool = (0, _judgeArea.judge)(lat, lon, maxRadiu);
      _area.removeSingleArea(pointId);
      getInterpPoints(lon, lat, radiusArr, pointId, bool);
      spots_global[pointId] = {
        lat: lat,
        lon: lon,
        radius: radius,
        typhoonspotid: pointId
      };
      $(".preWarn_cusWin").hide();
    } else alert(data.description);
  });
});

$(".preWarnDetales_close,#preWarnCancel").on("click", function () {
  $(".preWarn_cusWin").hide();
});

$(".warnDel").on("click", function () {
  var pointId = $(".early_head").attr("pointid");
  _area.removeTyphoonpot(pointId).then(function (data) {
    if (data.result === "S_OK") {
      _area.removeSingleArea(pointId);
      delete spots_global[pointId];
      hidePreWarnPopup();
    } else {
      alert(data.description);
    }
  });
});
var hidePreWarnPopup = exports.hidePreWarnPopup = function hidePreWarnPopup() {
  if ($(".early_warn").hasClass("on") === false) return;
  $(".early_warn").removeClass("on").show().stop().animate({
    bottom: "-4.8rem"
  });
  if ($(".rainForecast").hasClass("on") || $(".tgReflex").hasClass("on")) $(".tyCl_list,.getLonLat,.cloudPopup").stop().animate({
    bottom: 3.33 + "rem"
  });else $(".tyCl_list,,.getLonLat,.cloudPopup").stop().animate({
    bottom: 0.6667 + "rem"
  });
};

$(".cusDetales_center").on("click", "#addRadius", function () {
  $(this).removeAttr("id").removeClass("add").addClass("del");
  var radiusDiv = "<div class=\"wrapperDiv clearfix\"><dt>\u534A\u5F84</dt><dd class=\"radiusIn\"><input type=\"number\" name=\"radius\">\u516C\u91CC<span class=\"add\" id=\"addRadius\"></span></dd></div>";
  var $wrapper = $("#cusDetalesCenterDl .wrapper");
  $wrapper.append(radiusDiv);
  var height = $("#cusDetalesCenterDl .wrapper dt").size() * 1.25 * 75;
  $wrapper.scrollTop(height);
});

$(".cusDetales_center").on("click", ".del", function () {
  $(this).parents(".wrapperDiv").remove();
});

var calcScrollPos = function calcScrollPos() {
  var height = $("#cusDetalesCenterDl .wrapper dt").size() * 1.25;
  $("#cusDetalesCenterDl .wrapper").scrollTop(height);
};

var getTyphoonReport = function getTyphoonReport() {
  $.ajax({
    url: window.PAGE_CONFIG.BASE_URL + "/typhoon_report.txt?timeStamp=" + Date.now(),
    dataType: "text"
  }).then(function (data) {
    $(".typhoon_report_cont").html("&nbsp;&nbsp;&nbsp;&nbsp;" + data);
    $(".typhoon_report").fadeIn();
    1;
  });
};

$(".typhoon_report_close").on("click", function () {
  if ($(".warnsList").hasClass("on")) {
    $(".warnsList").removeClass("on");
  }
  $(".typhoon_report").hide();
  $(".typhoon_report_cont").html("");
});

$(".historyTyphone").bind("click", function () {
  if ($(this).find("img").attr("src") == "./assets/lishitaifeng.png") {
    $(this).find("img").attr("src", "./assets/lishitaifeng_pre.png");
    $(this).addClass("on");
  } else {
    $(this).find("img").attr("src", "./assets/lishitaifeng.png");
    $(this).removeClass("on");
  }
});

$(".typhoonPublish .forecast").on("click", function () {
  if ($(this).find("img").attr("src") == "./assets/typhoon_publish.png") {
    $(this).find("img").attr("src", "./assets/typhoon_publish_on.png");
  } else {
    $(this).find("img").attr("src", "./assets/typhoon_publish.png");
  }
});

$(".mainCityRanging").bind("click", function () {
  if (!$(".drawer").hasClass("a")) {
    $(".maincityrange").css("display", " block");
  }
  $(this).find("img").attr("src", "./assets/maincityR.png");
});

$(".history_close").on("click", function () {
  $(".historycusDetales").removeClass("top5");
  $(".historycusDetales").css("display", "none");
  $(".sleYear,.historylist").removeClass("historyupclass");
  $(".historyTyphone").find("img").attr("src", "./assets/lishitaifeng.png");
  $(".drawer img").css("bottom", "2rem");
});

$(".yearlist .arrows").on("click", function () {
  $(this).toggleClass("arrowsDown");
  if ($(this).hasClass("arrowsDown")) {
    $(".onlist").addClass("yearlistdown");
  } else {
    $(".onlist").removeClass("yearlistdown");
  }
});
$(document).click(function (event) {
  var _con = $(".yearlist .arrows");
  if (!_con.is(event.target) && _con.has(event.target).length === 0) {
    $(".yearlist .arrows").removeClass("arrowsDown");
    $(".onlist").removeClass("yearlistdown");
  }
});

$(".close_range").on("click", function () {
  $(".maincityrange").css("display", "none");
  $(".mainCityRanging").find("img").attr("src", "./assets/maincityR.png");
});

$(function () {
  $(".drawer").click(function (event) {
    event.stopPropagation();
    $(".tyCl_list ").toggleClass("draweron");
    return false;
  });

  $(document).click(function (event) {
    var _con = $(".tyCl_list");
    if (!_con.is(event.target) && _con.has(event.target).length === 0) {
      $(".tyCl_list").removeClass("draweron");
      $(".drawer").find("img").attr("src", "./assets/gb.png");
    }
    $(".publishList").css("display", "none");
    $(".forecast li img").attr("src", "./assets/typhoon_publish.png");
  });
});

$(".drawer").click(function () {
  if ($(".drawer").find("img").attr("src") == "./assets/gb.png") {
    $(".drawer").find("img").attr("src", "./assets/gbpre.png");
  } else {
    $(".drawer").find("img").attr("src", "./assets/gb.png");
  }
});
$(".buttonPlay").on("click", function () {
  if ($(this).find("img").attr("src") == "./assets/thunderstorm_play@3x.png") {
    $(this).find("img").attr("src", "./assets/thunderstorm_stop@3x.png");
  } else {
    $(this).find("img").attr("src", "./assets/thunderstorm_play@3x.png");
  }
});
$(".historycusDetales .historyup").on("click", function () {
  $(".sleYear,.historylist").toggleClass("historyupclass");
  $(".historycusDetales").toggleClass("top5");
  if ($(".historycusDetales").hasClass("top5")) {
    $(".drawer img").css("bottom", "2.7rem");
  } else {
    $(".drawer img").css("bottom", "2rem");
  }
  $(".historyup span").toggleClass("his_toogle_up");
});

$(".typhoon_cusWin .historyup").on("click", function () {
  $(".cusDetales_centerTy").toggleClass("match5");
  if ($(".cusDetales_centerTy").hasClass("match5")) {
    $(".drawer img").css("bottom", "2.7rem");
  } else {
    $(".drawer img").css("bottom", "2rem");
  }
  $("#taifeng_match").toggleClass("his_toogle_up");
  $("#simTyphoon").toggleClass("ele_hide");
});
$(".chose_typhoon_close").on("click", function () {
  hideSim('.typhoon_cusWin', 0);
});

$(document).on("click", function (event) {
  var _con = $(".tyListUl_com");
  if (!_con.is(event.target) && _con.has(event.target).length === 0) {
    $(".mapImg").css("display", "none");
    $(".tyListUl_com .changemap").attr("src", "./assets/typhoon_map@3x.png");
    $(".tyListUl_com .changemap").removeClass("on");
  }
});
$(".historyup").on("click", function () {
  $(this).toggleClass("down");
  if ($(this).hasClass("down")) {
    $(".historyTitle").text("展开");
  } else {
    $(".historyTitle").text("收起");
  }
});


//////////////////
// WEBPACK FOOTER
// ./js/typhoonDom.js
// module id = 25
// module chunks = 0